import React from 'react';
import styles from './index.module.css';
import { useStore } from '../../lib/store';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Step } from './step';
import { Grid, Column } from '../ui/Grid';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';

export const StepCompany = ({
  number,
  title,
  status,
  isLast
}) => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  
  const { 
    company, 
    setCompany,
    website, 
    setWebsite,
    location, 
    setLocation,
    increaseStep
  } = useStore();

  const canContinue = company && website && Object.keys(errors).length === 0;

  const onSubmit = (data) => {
    if(!data.company || !data.website) return;
    increaseStep(1);
  }

  return (
    <Step {...{number, title, status, isLast}}>
      <p className={styles.description}>Next, tell us about your company or organization.</p>
      <form onSubmit={handleSubmit(async (data) => onSubmit(data))}>
        <Grid className={styles.inputGroup}>
          <Column span={[12]}>
            <Input
              label="Company Name"
              name="company"
              required
              {...register("company", {
                required: "Company name is required",
                onChange: (e) => setCompany(e.target.value)
              })}
              error={errors.company}
            />
          </Column>
          <Column span={[12]}>
            <Input
              label="Website"
              name="website"
              required
              {...register("website", {
                required: "Website is required",
                onChange: (e) => setWebsite(e.target.value)
              })}
              error={errors.website}
            />
          </Column>
          <Column span={[12]}>
            <Input
              label="Business address (if applicable)"
              name="location"
              {...register("location", {
                onChange: (e) => setLocation(e.target.value)
              })}
              error={errors.location}
            />
          </Column>
        </Grid>
        
        {Object.keys(errors).length > 0 && (
          <div className={styles.errors}>
            <ErrorMessage
              errors={errors}
              name="company"
              render={({ message }) => <p>{message}</p>}
            />
            <ErrorMessage
              errors={errors}
              name="website"
              render={({ message }) => <p>{message}</p>}
            />
            <ErrorMessage
              errors={errors}
              name="location"
              render={({ message }) => <p>{message}</p>}
            />
          </div>
        )}
        
        <div className="actions">
          <Button 
            type="submit" 
            value="Submit" 
            icon="check"
            fullWidth
            disabled={canContinue ? false : true} 
          >
            {canContinue ? 'Continue to next step' : 'Please complete the form'}
          </Button>
        </div>
      </form>
    </Step>
  );
}